import React, { useMemo, useRef } from 'react'
import styled from 'styled-components'
import config from 'constants/config'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { buildRoomPackageOptionsViewOrder } from 'lib/offer/offerPageUtil'
import { getOfferExtra } from 'selectors/offerExtraSelector'
import { getDurationPackageOptions, OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import LayoutContainer from 'components/Common/LayoutContainer'
import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FlashHotelRoomOptionVariant from './FlashHotelRoomOptionVariant'
import { arrayToObject } from 'lib/array/arrayUtils'
import { InOfferFlowContext } from './RoomOptionsContext'

const PackagesLayoutContainer = styled(LayoutContainer)`
  padding: 0;
`

interface Props {
  offer: App.HotelOffer;
  packageOptions: Array<OfferPackageOptionView>;
  showFlightInformation?: boolean;
  offerExtra?: App.OfferExtra;
}

function FlashHotelPackageOptionsVariant(props: Props) {
  const {
    offer,
    packageOptions,
    showFlightInformation,
    offerExtra,
  } = props

  const packageStartRef = useRef<HTMLDivElement>(null)

  const bookedTodayByRoom = useMemo(() => {
    return arrayToObject(offerExtra?.roomsPurchasesToday ?? [],
      room => room.roomTypeId,
      room => room.purchases,
    )
  }, [offerExtra])

  const packageOptionsByRoom = useMemo(() => {
    return buildRoomPackageOptionsViewOrder(packageOptions)
  }, [packageOptions])

  return (
    <VerticalSpacer gap={16}>
      <LayoutContainer>
        <Heading variant="heading4">Room Options</Heading>
      </LayoutContainer>

      <PackagesLayoutContainer>
        <InOfferFlowContext.Provider value>
          <VerticalSpacer gap={16} ref={packageStartRef}>
            {packageOptionsByRoom.map((item) =>
              <FlashHotelRoomOptionVariant
              key={item.roomId}
              offer={offer}
              bookedToday={bookedTodayByRoom[item.roomId]}
              packageViews={item.packageViews}
            />,
            )}
          </VerticalSpacer>
        </InOfferFlowContext.Provider>
      </PackagesLayoutContainer>

      {showFlightInformation && (
        <LayoutContainer>
          <Caption variant="medium" align="center">
            *Price is indicative and based on sample return fares (inclusive of booking fees on Low Cost Carriers). To view live pricing, conduct a full search. {config.brandConfig.name} full Terms and Conditions apply.
          </Caption>
        </LayoutContainer>
      )}
    </VerticalSpacer>
  )
}

export default withOfferPageAndReduxState(
  (state, appState) => ({
    offer: state.offer,
    packageOptions: getDurationPackageOptions(state, appState),
    offerExtra: getOfferExtra(appState, state.offer?.id),
  }),
)(FlashHotelPackageOptionsVariant)
